module.exports = __webpack_public_path__ + "img/circle-close-btn.9f6041f2.svg";